import { Injectable, EventEmitter  } from '@angular/core';
import { Http, Response , Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router} from '@angular/router';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class GetdataService {

  constructor(private http: Http ,private router:Router) { }



public u_data = {};

    setValue(option, value) {

   
    this.u_data[option] = value;
    this.u_data[option] = value;
    this.u_data[option] = value;
    this.u_data[option] = value;
    this.u_data[option] = value;
    this.u_data[option] = value;
    this.u_data[option] = value;
    this.u_data[option] = value;
   this.u_data[option] = value;
    this.u_data[option] = value;
    this.u_data[option] = value;
  


    }

    getdata() {

        return this.u_data;
    }   







      selectId;

 getUserData()
    {
    const headers=new Headers({'Content-Type': 'application/json'});
     return this.http.get('http://gunadhyasoft.com/girswebservices/getdetail_byId.php?id='+this.selectId+'')
     .map(
    (response: Response)=>
      response.json())
     

    }

    sendUserData()
   {


          console.log("In send user data"+this.getdata());



        return this.http.get('http://gunadhyasoft.com/girswebservices/insert_feedback.php?candidate_id='+this.selectId+'_id=&c_rating='+this.u_data["c_rating"]+'&p_rating= '+this.u_data["p_rating"]+'&a_rating='+this.u_data["a_rating"]+'&t_rating='+this.u_data["t_rating"]+'&c_cmt='+this.u_data["c_cmt"]+'&p_cmt='+this.u_data["p_cmt"]+'&a_cmt='+this.u_data["a_cmt"]+'&t_cmt='+ this.u_data["t_cmt"]+'&comment='+this.u_data["comment"] +'&final_cmt= '+ this.u_data["final_cmt"] +'&remark= '+ this.u_data["remark"] +'')
          .map(
         (response: Response)=>
             {
            console.log("in senduserdata  "+response.json());

            if(response.json() == "Success")
            {
              
             this.deletedata_byid(); 
this.router.navigate(['interviewdetail']);
          alert("Feedback submitted successfully");
         
 
        return true;
            }

         }
           )


     }
deletedata_byid()
{

console.log("In delete rating");

 return this.http.get('http://gunadhyasoft.com/girswebservices/deleteby_selectedid.php?id='+this.selectId+'')
          .map(
         (response: Response)=>
           response.json())

 

}




     getselected_Id(num) {
     this.selectId = num;

     console.log("in event emitter"+num);
     
  }
 


}



// WEBPACK FOOTER //
// C:/Users/USer/Interviewfeedback/src/app/interviewrating/getdata.service.ts